import { Add, DoubleArrow, Edit} from '@mui/icons-material';
import { Autocomplete, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Tooltip } from '@mui/material';
import React,{useState,useEffect, useRef} from 'react'
import SelectParty from '../../party/components/SelectParty';
import voucherServices from '../voucherServices';
import { useNavigate } from 'react-router-dom';
import { useKeyPress } from '../../../../../../hooks/useKeyPress';
import moment from 'moment/moment';
import { useAlert } from '../../../../../../context/AlertContext';
import { useAppData } from '../../../../../../context/AppDataContext';

function GenerateSalePurchaseVoucherForm({data,callBack,voucherType }) {
    const navigate = useNavigate();
    const submitButtonRef = useRef();
    const { AppAlert } = useAlert();
    const {userDD,  getDDDataById, } = useAppData();
    
    const[dialogStatus, setDialogStatus] = useState(false);
    const[saving,setSavingStatus] = useState(false);
    const[party,setParty] = useState(null);
    const [draftList,setDraftList] = useState(null);
    
    
    const addNew = ()=>{
        setParty(null);
        setDialogStatus(true)
    }


    const getDraftList = () =>{
        let payload = {
            voucherType:voucherType,
            ledgerId:party.ledgerId,
        }
        setSavingStatus(true);
        setDraftList(null);
        voucherServices.getDraftList(payload).then(res=>{
           setDraftList(res.data);
           if(res.data.length == 0 ){
            setTimeout(()=>{
                submitButtonRef.current.focus();
            },100)
           }
        }).catch(error=>{
            console.log(error)
        }).finally(()=>{
            setSavingStatus(false);
        })
        
    }

    const onSubmit = () =>{
        let payload = {
            voucherType:voucherType,
            partyId:party.id,
            ledgerId:party.ledgerId,
            voucherDate:moment().format(moment.HTML5_FMT.DATE),
            paymentDueDate:moment().format(moment.HTML5_FMT.DATE),
        }

        if(party.taxDetails){
            payload.partyGstin = party.taxDetails.gstin;
            payload.partyPan = party.taxDetails.panNo;
            payload.registrationType = party.taxDetails.registrationType;
            payload.tdsApplicable = party.taxDetails.tdsApplicable;
        }
        
        setSavingStatus(true);
        voucherServices.save(payload).then(res=>{
            AppAlert(res.msg);
            navigate("/voucher/sale-purchase/details/"+res.id)
            setDialogStatus(false);
        }).catch(error=>{
            console.log(error)
        }).finally(()=>{
            setSavingStatus(false);
        })
        
    }

    useKeyPress('F8', addNew, { condition: voucherType === 'Sale' }, [voucherType]);
    useKeyPress('F9', addNew, { condition: voucherType === 'Purchase' }, [voucherType]);
    useEffect(()=>{
        setDraftList(null);
        if(party){
            getDraftList();
            //submitButtonRef.current.focus();
        }
    },[party])

    return (
        <>
            <Tooltip title="Add New ">
                <button type="button" className='btn btn-default w-100 text-start' onClick={addNew}>
                    <Add /> {voucherType} Voucher
                    <span style={{ fontSize: '0.85em', opacity: 0.7, marginLeft: '8px' }}>
                        ({voucherType === 'Sale' ? 'F8' : 'F9'})
                    </span>
                </button>
            </Tooltip>
            
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                fullWidth={true}
                maxWidth="md"
            >
                <DialogTitle>{voucherType} Voucher</DialogTitle>
                <DialogContent>
                    <div className='row mt-2'>
                        <div className='col-md-12 mb-3'>
                            {dialogStatus &&
                                <SelectParty party={party} setParty={setParty} partyRole={ voucherType=="Sale"? {value:1} : {value:2}} /> 
                            }
                        </div>
                    </div>

                    {saving &&
                        <div className='row'>
                            <div className='col-md-12 text-center'><CircularProgress/></div>
                        </div>
                    }

                    {draftList && draftList.length > 0 &&
                        <div className='row'>
                            <div className='col-md-12'>
                                <p className='text-muted small mb-0'>We found existing vouchers for this party. Choose one to view details or create a new one.</p>
                            </div>
                            <div className='col-md-12'>
                                <div className="table-responsive shadow-sm rounded">
                                    <table className="table table-hover align-middle bg-white mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th scope="col" className="py-3">Created</th>
                                                <th scope="col" className="py-3">Updated</th>
                                                <th scope="col" className="py-3">Created By</th>
                                                {/*<th scope="col" className="py-3">Grand Total</th> */}
                                                <th scope="col" className="py-3 text-end">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {draftList.map(voucher => (
                                                <tr key={voucher.id}>
                                                    {/* Created Date */}
                                                    <td>
                                                        <span className="small text-secondary">
                                                            {moment(voucher.created_at).format("lll")}
                                                        </span>
                                                    </td>

                                                    {/* Updated Date */}
                                                    <td>
                                                        <span className="small text-secondary">
                                                            {moment(voucher.updated_at).format("lll")}
                                                        </span>
                                                    </td>

                                                    {/* User / Created By */}
                                                    <td>
                                                        <span className="fw-semibold text-dark">
                                                            {getDDDataById(userDD, voucher.userId)?.label || 'N/A'}
                                                        </span>
                                                    </td>

                                                    {/* Grand Total */}
                                                    {/*
                                                    <td>
                                                        <span className="fw-bold text-success">
                                                            {voucher.grandTotal}
                                                        </span>
                                                    </td>
                                                    */}

                                                    {/* Action Button */}
                                                    <td className="text-end">
                                                        <button 
                                                            className="btn btn-outline-primary btn-sm d-inline-flex align-items-center gap-1 px-3 shadow-sm" 
                                                            type="button"  
                                                            onClick={() => {
                                                                navigate("/voucher/sale-purchase/details/" + voucher.id);
                                                                setDialogStatus(false);
                                                            }}
                                                        >
                                                            <span>View</span>
                                                            <DoubleArrow />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    }

                </DialogContent>
                {draftList &&
                    <DialogActions>
                        <button className='btn btn-outline-primary' onClick={()=>setDialogStatus(false)} >Cancel</button>
                        <button disabled={party === null} className='btn btn-primary' onClick={onSubmit} ref={submitButtonRef} >Create New Voucher <DoubleArrow/> </button>
                    </DialogActions>
                }
            </Dialog>
        </>
    )
}

export default GenerateSalePurchaseVoucherForm